<div class="modal-header">
  <h4 class="modal-title">Bookmark {{WebSiteMetaData.Title}}</h4>
  <a href="javascript:void(0)" style="color: black;" data-dismiss="modal">
    <i class="fa fa-times" aria-hidden="true"></i>
  </a>
</div>
<div class="modal-body">
  <div class="row" >
    <div class="col-md-12">
      <label id="lblMessage" style="display: none;" class="alert alert-info"></label>
      <button type="submit" class="btn btn-primary" (click)="Bookmark();" *ngIf="!submitted">
        Confirm
      </button>
      <button class="btn btn-primary"  *ngIf="submitted">
        <manik-button-loader></manik-button-loader>
      </button>
      <button type="button" class="btn btn-danger" data-dismiss="modal">Close</button>
    </div>
  </div>
  <!-- <app-visitor-handler *ngIf="!UserLoggedIn" [CountryID]="WebSiteMetaData.COUNTRYID" [PortalName]="WebSiteMetaData.PC" [PortalID]="WebSiteMetaData.PID" (visitorLoggedIn)="CheckUserLoggedIn();Emit();"></app-visitor-handler> -->
</div>
